import { render, staticRenderFns } from "./PromotionInfo.vue?vue&type=template&id=66cc6e82"
import script from "./PromotionInfo.vue?vue&type=script&lang=js"
export * from "./PromotionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports